import {shopModule} from '../../module.js';

shopModule.directive('hover', function() {
    return {
        restrict: "A",
        link: function(scope, element) {
            element.bind('mouseenter', function(){
                element.siblings().removeClass('selected');
                if (!element.hasClass('notSelectable')) {
                    element.addClass('selected');
                }
            }).bind('mouseleave', function(){
                if (!element.hasClass('notSelectable')) {
                    element.removeClass('selected');
                }
            }).bind('mousemove', function() {
                if (!element.hasClass('notSelectable')) {
                    if (!element.hasClass('selected')) {
                        element.siblings().removeClass('selected');
                        element.addClass('selected');
                    }
                }
            });
        }
    };
});
